import dayjs from "dayjs";

import { shortMonthAndYear, shortMonthDayAndYear } from "@similarweb/pro-logic-components";

import { translate } from "app/filters/i18nFilter";

import type { TimeGranularity } from "../../types";

export const formatTooltipTitle = (
    timestamp: number,
    granularity: TimeGranularity,
    isPeriodOverPeriod?: boolean,
): string => {
    const date = dayjs.utc(timestamp);

    if (isPeriodOverPeriod) {
        return date.format(shortMonthAndYear);
    }

    switch (granularity) {
        case "Daily":
            return date.format("dddd, MMMM DD, YYYY");

        case "Weekly": {
            const weekStart = date.startOf("week");
            const weekEnd = date.endOf("week");
            return translate("market.research.overview.comparison.highlevel.chart.tooltip.title.weekly", {
                from: weekStart.format(shortMonthDayAndYear),
                to: weekEnd.format(shortMonthDayAndYear),
            });
        }

        case "Monthly":
            return date.startOf("month").format(shortMonthDayAndYear);

        default:
            return date.format(shortMonthDayAndYear);
    }
};
